module.exports = __webpack_public_path__ + "img/real-tag.f43207a8.png";